// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"breadcrumbs_breadcrumbs__sNIDT","split":"breadcrumbs_split__3L3Uw"};